"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HowCanWeHelp = void 0;
var _login = require("@ori/login");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("../../constants");
var _hooks = require("../../hooks");
var _constants2 = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const HowCanWeHelp = ()=>{
    const { getTestId } = (0, _testidGenerator.default)();
    const { translations } = (0, _hooks.useTranslations)();
    const { doLogin } = (0, _login.useLogin)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Root, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Inner, {
            "data-testid": getTestId(_constants2.HOW_CAN_WE_HELP),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Title, {
                    children: translations.needMoreHelp
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Image, {
                    src: _constants.HOW_CAN_WE_HELP_IMAGE_URL,
                    alt: translations.needMoreHelp
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Button, {
                    href: _constants.CONTACT_US_PATH,
                    children: translations.contactUs
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.LoginSection, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.ContactBrandPartnerInfo, {
                            children: translations.youCanContactBrandPartner
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Button, {
                            onClick: doLogin,
                            children: translations.logIn
                        })
                    ]
                })
            ]
        })
    });
};
exports.HowCanWeHelp = HowCanWeHelp;
